// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Ob7a","shadow":"_3NCC3","hidden":"_170VA","section":"UNjnV","disabledOverlay":"_2jdoD"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Box/styles.css
// module id = 1246
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16 17